import initModernizr    from '../modernizr/modernizr';

// const queryString = require('query-string');
const qs = require('qs');

let selectedFilterElements = {};
let selectedFilters = {};
let recipesPage = 2;
let historyStatePushed = false;
const $closeButton = $('.recipe-detail_close');
const $loadMoreBtn = $('.recipes-load_more');
const recipesMoreUrlPath = $loadMoreBtn.attr('href');
const $selectedContainer = $('.sidebar.sidebar-filter').find('.sidebar-filter_selected-items');

function closeRecipeDetail() {
    let shouldCloseWindow = false;

    if (window.location.hash.indexOf('new-tab') !== -1) {
        shouldCloseWindow = true;
        history.replaceState({}, document.title, window.location.pathname);
    }

    $closeButton.on('click', (e) => {
        if (shouldCloseWindow) {
            e.preventDefault();
            window.close();
        }
    })
}

function checkInitialFilters() {
    if (!window.location.search.length) {
        return;
    }

    selectedFilters = qs.parse(window.location.search, { comma: true });

    Object.keys(selectedFilters).forEach(key => {
        if (!Array.isArray(selectedFilters[key])) {
            selectedFilters[key] = [selectedFilters[key]];
        }

        selectedFilters[key].forEach(id => {
            let $item = $(`.sidebar_submenu-item a[data-filter-model-key="${key}"][data-filter-model-id="${id}"]`);
            let filterID = $item.attr('id');

            selectedFilterElements[filterID] = $item.clone().removeAttr('id').attr('data-filter-id', filterID).addClass('sidebar-filter_selected-item');
            $item.closest('.sidebar_submenu-item').addClass('sidebar_submenu-item--active');
        });
    });

    renderSelectedFilterElements();
}

function initHistoryHandling() {
    let baseURL = window.location.pathname;

    if (window.location.search.length) {
        baseURL += window.location.search;
    }

    window.onpopstate = function(event) {
        selectedFilterElements = {};
        fetchSelectedFilterElements();
        $('.sidebar_submenu-item').removeClass('sidebar_submenu-item--active');
    };
}

function renderSelectedFilterElements() {
    $selectedContainer.empty();

    selectedFilters = {};

    Object.keys(selectedFilterElements).forEach(item => {
        if (!(selectedFilterElements[item].attr('data-filter-model-key') in selectedFilters)) {
            selectedFilters[selectedFilterElements[item].attr('data-filter-model-key')] = [];
        }

        if (!selectedFilters[selectedFilterElements[item].attr('data-filter-model-key')].includes(selectedFilterElements[item].attr('data-filter-model-id'))) {
            selectedFilters[selectedFilterElements[item].attr('data-filter-model-key')].push(selectedFilterElements[item].attr('data-filter-model-id'));
        }

        $selectedContainer.append(selectedFilterElements[item]);
    });

    if (Object.keys(selectedFilterElements).length) {
        $selectedContainer.append('<a href="#" id="cancelAll" class="sidebar-filter_selected-item sidebar-filter_selected-item--inverted">Zrušiť všetky</a>');
    }
}

function fetchSelectedFilterElements() {
    renderSelectedFilterElements();

    let url = `${window.location.pathname}?${qs.stringify(selectedFilters, {arrayFormat: 'comma'})}`;

    axios.get(url)
        .then(function (response) {
            if (response.data.lastPage) {
                $loadMoreBtn.hide();
            } else {
                $loadMoreBtn.show();
            }

            showFilteredRecipes(response.data.response);

            $('html, body').animate({ scrollTop: 0 }, 600);

            trackPageView(qs.stringify(selectedFilters, {arrayFormat: 'comma'}));

            if (historyStatePushed) {
                window.history.replaceState({
                    filters: selectedFilters
                }, document.title, url);
            } else {
                historyStatePushed = true;

                window.history.pushState({
                    filters: selectedFilters
                }, document.title, url);
            }

        })
        .catch(function (error) {
            console.log(error);
        })
        .then(function () {
            // always executed
        });
}

function showFilteredRecipes(html) {
    $('.recipes-grid').empty().append(html);
    initModernizr();
}

function addItemToSelected(event) {
    event.preventDefault();

    let $item = $(event.currentTarget);
    let filterID = $item.attr('id');

    if($item.closest('.sidebar_submenu-item').hasClass('sidebar_submenu-item--active')) {
        return;
    }

    selectedFilterElements[filterID] = $item.clone().removeAttr('id').attr('data-filter-id', filterID).addClass('sidebar-filter_selected-item');
    $item.closest('.sidebar_submenu-item').addClass('sidebar_submenu-item--active');

    fetchSelectedFilterElements();
}

function removeItemFromSelected(event) {
    event.preventDefault();

    let $item = $(event.currentTarget);

    if($item.attr('id') == 'cancelAll') {
        selectedFilterElements = [];

        $('.sidebar_submenu-item').removeClass('sidebar_submenu-item--active');
    } else {
        let filterID = $item.attr('data-filter-id');

        delete selectedFilterElements[filterID];

        $(`#${filterID}`).closest('.sidebar_submenu-item').removeClass('sidebar_submenu-item--active');
    }

    fetchSelectedFilterElements();
}

function loadMoreRecipes(event) {
    event.preventDefault();

    if ($loadMoreBtn.is(':disabled')) {
        return;
    }
    $loadMoreBtn.attr('disabled', true);

    getRecipes(recipesPage);
}

function getRecipes(page) {
    let url = `/${recipesMoreUrlPath}`;

    if (window.location.search.length) {
        url += window.location.search;
    }

    axios.get(url, {
        params: {
            page: page
        }
    }).then(function (response) {
        $('.recipes-grid').append(response.data.response);

        if (page > 1) {
            $('html,body').animate({scrollTop: '+=600px'}, 600);
        }
        recipesPage++;
        if (response.data.lastPage) {
            $loadMoreBtn.hide(0);
        }

        $loadMoreBtn.attr('disabled', false);
    }).catch(function (error) {
        console.log('Recipes could not be loaded.');
    });
}

function shareOnFacebook(event) {
    event.preventDefault();

    if(!window.cc.allowedCategory('targeting')) {
        $('.cookie-alert .cookie-alert_header').addClass('share');
        $('.cookie-alert').fadeIn();
        return;
    }

    FB.ui({
        method: 'share',
        href: $(this).attr('data-url'),
    }, function(response){});

    trackEvent('Share', 'click');
}

$(function () {
    closeRecipeDetail();
    checkInitialFilters();
    initHistoryHandling();

    $('.sidebar.sidebar-filter .sidebar_submenu-item a').click(addItemToSelected);
    $('.sidebar-filter').on('click', '.sidebar-filter_selected-item', removeItemFromSelected);
    $(document).on('click', '.recipes-load_more', loadMoreRecipes);
    $(document).on('click', '.recipe-detail_share-btn', shareOnFacebook);

    $('.videos-grid_item').click(event =>  {
        let $item = $(event.currentTarget);
        let youtubeID = $item.attr("data-youtube-id");

        $item.find('.aspect-ratio').find('img').fadeOut(400, () =>  {
            $item.find('.aspect-ratio').append(`<iframe src="https://www.youtube.com/embed/${youtubeID}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`).hide().fadeIn(400);
        })
    });

    if(window.innerWidth >= 768) {
        $('.recipe-media').css('height', $('.recipe-detail').outerHeight());
    }

    window.addEventListener('resize', (event) => {
        if(window.innerWidth >= 768) {
            $('.recipe-media').css('height', $('.recipe-detail').outerHeight());
        } else {
            $('.recipe-media').css('height', 'auto');
        }
    });

    $('.recipe-media, .recipe-detail').on("scroll", function() {
        $('.recipe-media, .recipe-detail').scrollTop($(this).scrollTop());
    });
});
